import React from 'react';
import {
  HISTORY_STATUS_CONFIG,
  formatDate,
  toHistoryKey,
  getLatestHistoryEntry,
} from './useSensorDataTab.utils';
import S from './SensorDataTab.module.scss';

export const buildSensorDataColumns = ({
  handleDelete,
  getSensorNameById,
  historyMap,
  onOpenHistory,
  handleRestore,
}) => [
  {
    field: 'sensor_id',
    headerName: 'ID capteur',
    minWidth: 90,
    flex: 0.8,
    editable: false,
    headerAlign: 'left',
    align: 'left',
    renderCell: ({ row, value }) => {
      const sensorId = Number(row?._sensorId ?? value);
      return getSensorNameById(sensorId);
    },
  },
  {
    field: 'pk_test',
    headerName: 'PK Test',
    minWidth: 90,
    flex: 0.8,
    editable: false,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'position_in_sensor',
    headerName: 'Position',
    minWidth: 95,
    flex: 0.8,
    editable: false,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'time_unix',
    headerName: 'Date / Heure',
    minWidth: 170,
    flex: 1.6,
    editable: true,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: 'value',
    headerName: 'Valeur',
    minWidth: 120,
    flex: 1,
    editable: true,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'calc_value',
    headerName: 'Valeur calculée',
    minWidth: 145,
    flex: 1.2,
    editable: true,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: '_dirty',
    headerName: 'État',
    minWidth: 130,
    flex: 1,
    editable: false,
    sortable: false,
    renderCell: ({ row }) => {
      const key = toHistoryKey(row._sensorId, row.pk_test);
      const entries = historyMap ? (historyMap[key] ?? []) : [];
      const lastEntry = getLatestHistoryEntry(entries);
      const config = lastEntry
        ? HISTORY_STATUS_CONFIG[lastEntry.update_type]
        : null;
      const label = config ? config.label : 'Non modifié';

      return (
        <button
          type="button"
          className={S.btnEtatBadge}
          onClick={() => onOpenHistory(row, entries)}
          title="Voir l'historique"
        >
          <span className={config ? S[config.cssClass] : S.badgeSynchro}>
            {label}
          </span>
        </button>
      );
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    minWidth: 95,
    flex: 0.8,
    sortable: false,
    filterable: false,
    renderCell: ({ id, row }) => {
      const key = toHistoryKey(row._sensorId, row.pk_test);
      const entries = historyMap ? (historyMap[key] ?? []) : [];
      const latestEntry = getLatestHistoryEntry(entries);

      if (latestEntry?.update_type === 'Delete') {
        return (
          <button
            type="button"
            className={S.actionRestoreButton}
            title="Restaurer"
            onClick={() => handleRestore(id)}
          >
            <span className={S.iconRestore}>↺</span>
          </button>
        );
      }

      return (
        <button
          type="button"
          className={S.actionDeleteButton}
          title="Supprimer"
          onClick={() => handleDelete(id)}
        >
          <span className={S.iconDelete}>✕</span>
        </button>
      );
    },
  },
];
